
import _ from 'lodash';
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useState, useRef } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NavLink } from "react-router-dom";
import DataView from 'Components/DataView';

//Actions
import {
    lastReadingRequestDetailsRequest,
    genericExportSend,
    clearRedux,
} from 'Redux/actions';

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

//Styles
import './index.scss';
const LastReadingsDetail = (props) => {

    const { messages } = useIntl();
    const dispatch = useDispatch();
    const tableRef = useRef(null)

    //Redux States
    const {
        openModal,
        loading,
        result,
        data,
        total
    } = useSelector(state => state.lastReadingDetailsRedux);

    const [columns, setColumns] = useState([
        {
            key: "accountName",
            title: messages['lastreadings_details_account_name'],
            width: 250,
            show: true,
            code: 'lastreadings_details_account_name',
            export: true,
            exportCell: "accountName",
            functionString: "return row?.accountName",
            render: (item) => {
                return (
                    <NavLink to={`/app/accounts/overview/${item?.accountId}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.accountName}</span>
                    </NavLink>
                )
            }
        },
        {
            key: "deviceId",
            title: messages['lastreadings_details_device_id'],
            width: 200,
            show: true,
            code: 'lastreadings_details_device_id',
            export: true,
            exportCell: "esn",
            functionString: "return row?.esn",
            render: (item) => {
                return (
                    <NavLink to={`/app/devices/overview/${item?.deviceId}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.esn}</span>
                    </NavLink>
                )
            }
        },
        {
            key: "manufacturerName",
            title: messages['lastreadings_details_manufacturer'],
            width: 150,
            show: true,
            code: 'lastreadings_details_manufacturer',
            export: true,
            exportCell: "manufacturerName",
            functionString: "return row?.manufacturerName",
            render: (item) => {
                return (
                    <span>{item?.manufacturerName}</span>
                )
            }
        },
        {
            key: "age",
            title: messages['lastreadings_details_age'],
            width: 120,
            show: true,
            code: 'lastreadings_details_age',
            export: true,
            exportCell: "age",
            functionString: "return row?.age",
            render: (item) => {
                return (
                    <span>{item?.age}</span>
                )
            }
        },
        {
            key: "eventName",
            title: messages['lastreadings_details_event_name'],
            width: 150,
            show: true,
            code: 'lastreadings_details_event_name',
            export: true,
            exportCell: "eventName",
            functionString: "return row?.eventName",
            render: (item) => {
                return (
                    <span>{item?.eventName}</span>
                )
            }
        },
        {
            key: "lastMessageTime",
            title: messages['lastreadings_details_last_message_time'],
            width: 250,
            show: true,
            code: 'lastreadings_details_last_message_time',
            export: true,
            exportCell: "lastMessageTime",
            exportFormat: "timezone",
            functionString: `
                function formatDateWithTimezone(date, tz) {
                    let dateToformat = moment(date)
                    let formatted = moment(dateToformat).tz(tz).format("YYYY/MM/DD HH:mm:ss")
                    return formatted;
                }
                return row?.lastMessageTime ? formatDateWithTimezone(row.lastMessageTime, row.timezone) : ''
            `,
            render: (item) => {
                return (
                    <span>{getDateFormatted(item.lastMessageTime, "date", "datetime", null, item?.timezone)}</span>
                )
            }
        },
    ]);

    const closeModal = () => {
        dispatch(clearRedux("LASTREADING_REQUEST_DETAILS"))
        setColumns([])
    }

    const pagingHandler = (newToken) => {
        let payload = {
            id: data?.gadgetId,
            query: {
                level: 1,
                gadgetParams: JSON.stringify({
                    start: data?.start,
                    end: data?.end || data?.start + 190,
                    limit: 1000,
                    offset: result.length,
                })
            }
        }
        newToken && dispatch(lastReadingRequestDetailsRequest(payload, true))
    }

    const exportHandler = (type) => {

        let payload = {
            id: data?.gadgetId,
            query: {
                level: 1,
                gadgetParams: JSON.stringify({
                    start: data?.start,
                    end: data?.end,
                    limit: result.length,
                    offset: 0,
                })
            }
        }

        let query = `
            query getGadgetData($id: String!, $query: GadgetDataQuery) {
                result: getGadgetData(id: $id, query: $query)
            }
        `
        const headers = columns.filter(x => x.show && x.export).map(x => { return { header: x.title, column: x.key, functionString: x.functionString } });
        dispatch(genericExportSend(
            'Csv',
            query,
            payload,
            headers,
            { unit: 'pt', size: 'A4', orientation: 'portrait', fontSize: 12 },
            false,
            false,
            null,
            'devices',
            true
        ));
    }
     
    return (
        <div className='create-edit-modal'>
            <Modal
                open={openModal}
                title={`${messages['lastreadings_details_devices']} (${total})`}
                handleClose={() => closeModal()}
                position="right"
                size="small"
                loading={loading}
            >
                <ModalBody>
                    <div className="last-reading-table">
                        <DataView
                            ref={tableRef}
                            tableButtons={["export"]}
                            name="devices-readings"
                            exportName="devicesreadings"
                            dataGridExport
                            columns={columns}
                            externalData={result?.length ? result.map((item) => ({ ...item, accountName: item?.accountName?.replace(/,/g, '.') })): []}
                            topheight={255}
                            noSplit
                            noSearch
                            noFilters
                            disableItemSelection
                            noRefresh
                            noDensity
                            onChangePage={() => pagingHandler(result.length < total)}
                            externalDataTotal={total}
                            onChangeColumns={(items) => setColumns(items)}
                            noPreferences
                            nextToken={result.length < total}
                            infiniteScroll
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-dark-blue"
                        onClick={() => closeModal()}
                    >
                        {messages['common_close']}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default LastReadingsDetail;